module.exports = __webpack_public_path__ + "static/media/filled_bar_postlapSMAP.1b4d8c59.svg";